import { Component, Prop } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import UserMixin from '@/_mixins/user'

@Component({
    name: 'SubitemMenu',
    mixins: [UserMixin],
})
export default class SubitemMenu extends Mixins<MixinInterface>(UserMixin) {
    @Prop({ required: true }) item!: Record<string, any>
}
